import { createFileRoute } from '@tanstack/react-router'
import { CleverScorePage } from '@/pages/CleverScorePage'

const App = () => {
  return <CleverScorePage />
}

export const Route = createFileRoute('/cleverscore')({
  component: App,
})
